import axios from "axios";
import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

const OtpInput = ({
  phone,
  setIsVisible,
  SignupPage,
  name,
  bookPage,
  setBookPage,
}) => {
  const [otp, setOtp] = useState(""); // State for OTP input
  const [timer, setTimer] = useState(120); // Timer starts at 120 seconds
  const [isResendEnabled, setIsResendEnabled] = useState(false); // Disable resend OTP initially

  // Handle OTP input change
  const handleOtpChange = (event) => {
    setOtp(event.target.value);
  };

  const fetchProfileData = async (accessToken) => {
    try {
      const response = await axios.get(
        "https://htprdapi.hightable.ai/profile-members/profile",
        {
          headers: {
            authorization: `Bearer ${accessToken}`,
          },
        }
      );

      // console.log("Profile Data:", response.data.data);
      localStorage.setItem("@userAccount", response.data.data.id);
      localStorage.setItem("@userName", response.data.data.first_name);
      localStorage.setItem("@userPhone", response.data.data.phone);
      localStorage.setItem("@userPhoto", response.data.data.photo);
      localStorage.setItem("email", response.data.data.email);
    } catch (error) {
      console.error("Failed to fetch profile data:", error);
      localStorage.removeItem("@user");
      localStorage.removeItem("@userRefreshToken");
      localStorage.removeItem("@userName");
      localStorage.removeItem("@userPhone");
      localStorage.removeItem("@userAccount");
      localStorage.removeItem("@userPhoto");
    }
  };

  // Countdown timer logic
  useEffect(() => {
    if (timer > 0) {
      const interval = setInterval(() => {
        setTimer((prevTimer) => prevTimer - 1);
      }, 1000);
      return () => clearInterval(interval);
    } else {
      setIsResendEnabled(true); // Enable resend OTP when timer reaches 0
    }
  }, [timer]);

  const getDeviceType = () => {
    const userAgent = navigator.userAgent.toLowerCase();
    if (/mobile|android|iphone|ipad|tablet/i.test(userAgent)) {
      return "mobile";
    }
    return "web"; // Default to web if not mobile/tablet
  };

  const getAuthToken = async (event) => {
    event.preventDefault();

    const apiUrl = "https://htprdapi.hightable.ai/users/login-otp";

    const requestBody = {
      client_id: "CLIENT002",
      client_secret: "5PY02KdOpCX5FO93jSjPa7gKsBvQF",
      // is_signup: true ? true : false,
      login_type: "phone",
      grant_type: "password",
      otp_verify: otp,
      phone: phone,
      device_id: localStorage.getItem("deviceId"),
      device_type: getDeviceType(),
    };

    try {
      const response = await axios.post(apiUrl, requestBody, {
        headers: {
          "Content-Type": "application/json",
        },
      });

      if (typeof bookPage !== "undefined") {
        setBookPage(true);
        console.log("=======>bookPage", bookPage);
      }

      // console.log("Auth Token Response:", response.data.access_token);
      fetchProfileData(response.data.access_token);
      localStorage.setItem("@user", response.data.access_token);
      localStorage.setItem("@userRefreshToken", response.data.refresh_token);
      localStorage.setItem("@tokenExpiry", response.data.expires_in);
      setIsVisible(false);

      // setTimeout(() => {
      //   window.location.reload();
      // }, 2000);
    } catch (error) {
      if (error.response) {
        console.error("API Error:", error.response.status, error.response.data);
        toast.error("Failed to verify otp. Please enter correct otp.", {
          position: "top-center",
        });
      } else if (error.request) {
        toast.error("Failed to verify otp. Please enter correct otp.", {
          position: "top-center",
        });
      } else {
        toast.error("Failed to verify otp. Please enter correct otp.", {
          position: "top-center",
        });
      }
    }
  };

  const resendOtp = async (event) => {
    event.preventDefault();

    // Replace alert in resendOtp
    if (!isResendEnabled) {
      toast.warn("You are too fast! Please wait some time.", {
        position: "top-center",
      });
      return;
    }

    const body = {
      client_id: "CLIENT002",
      client_secret: "5PY02KdOpCX5FO93jSjPa7gKsBvQF",
      is_signup: false,
      phone: phone,
    };

    try {
      await axios.post("https://htprdapi.hightable.ai/users/login-otp", body, {
        headers: {
          "Content-Type": "application/json",
        },
      });

      // On successful OTP resend
      toast.success("OTP resent successfully!", { position: "top-center" });

      setTimer(120); // Reset timer to 2 minutes
      setIsResendEnabled(false); // Disable resend OTP until timer runs out
    } catch (error) {
      // On error in resendOtp
      console.error("Error resending OTP:", error.message);
      toast.error("Failed to resend OTP. Please try again later.", {
        position: "top-center",
      });
    }
  };

  return (
    <div className="no-margin w-form">
      <form
        id="wf-form-signup"
        name="wf-form-signup"
        data-name="signup"
        method="get"
        data-ms-form="signup"
        className="signup-container"
        data-wf-page-id="674c55a02ef3a7c29163821d"
        data-wf-element-id="8a99125d-fbbe-eda5-7895-cece5afc1721"
      >
        <div className="otp-wrapper -mt-5">
          <label htmlFor="6-Digit-Code" className="enter-otp-text">
            Enter 4-Digit Code
          </label>
          <div className="ms-input-wrap is-token">
            <input
              className="ms-token-input-2 w-input"
              maxLength={4}
              name="6-Digit-Code-2"
              data-name="6 Digit Code 2"
              placeholder={"0000"}
              minLength={4}
              type="text"
              id="6-Digit-Code-2"
              data-ms-member="token"
              required=""
              value={otp}
              onChange={handleOtpChange}
            />
            <div className="ms-input is-fake-token" />
            <div className="ms-input is-fake-token" />
            <div className="ms-input is-fake-token" />
            <div className="ms-input is-fake-token" />
            <div className="ms-token-overflow" />
          </div>
          {/* Timer Display */}
          <div className="enter-otp-text">
            Time remaining:{" "}
            <strong>{`${Math.floor(timer / 60)}:${String(timer % 60).padStart(
              2,
              "0"
            )}`}</strong>
          </div>
          {/* Resend OTP Link */}
          <div onClick={resendOtp} className="link-8">
            Resend
          </div>
        </div>
        <input
          type="submit"
          data-wait="Please wait..."
          className="button-4 w-button mb-10"
          defaultValue="Login"
          onClick={getAuthToken}
        />
      </form>
      <div className="w-form-done">
        <div>Thank you! Your submission has been received!</div>
      </div>
      <div className="w-form-fail">
        <div>Oops! Something went wrong while submitting the form.</div>
      </div>
    </div>
  );
};

export default OtpInput;